<div class="light">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid">
                <a [routerLink]="'/' + app?.languageCode+'/home'" class="navbar-brand logo mr30">
                    <img loading="lazy" src="assets/img/navbar/logo.svg" class="img-fluid" alt="Logo"
                        data-aos="fade-down" data-aos-duration="800" />
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justy-between" id="navbarNav">
                    <ul class="navbar-nav font-f">
                        <li class="nav-item m-2">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link"
                                [routerLink]="'/' + app?.languageCode+'/home'" routerLinkActive="active">{{
                                "NavBar.Home"
                                |
                                translate }}</a>
                        </li>

                        <!-- <SSR> -->
                        <div *ngIf="app.isPlatformServerVar" style="display: none;visibility:hidden;opacity: 0;">
                            <p *ngIf="router?.url?.includes('/en/')">Home</p>
                            <p *ngIf="router?.url?.includes('/en/')">About</p>
                            <p *ngIf="router?.url?.includes('/en/')">Blog</p>
                            <p *ngIf="router?.url?.includes('/ar/')">الرئيسية</p>
                            <p *ngIf="router?.url?.includes('/ar/')">من نحن</p>
                            <p *ngIf="router?.url?.includes('/ar/')">مقالات</p>
                        </div>
                        <!-- </SSR> -->

                        <li class="nav-item m-2">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link"
                                [routerLink]="'/' + app?.languageCode +'/about-us'" routerLinkActive="active">{{
                                "NavBar.About" | translate }}</a>
                        </li>

                        <li class="nav-item m-2">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link"
                                [routerLink]=" '/' + app?.languageCode +'/blog'" routerLinkActive="active">{{
                                "NavBar.Blog" | translate }}</a>
                        </li>

                        <li *ngIf=" this?.app?.getUserData()?.applicationType==2 &&
                            this?.app.getUserData()?.hasPendingHcpRequest==false && this?.app?.getUserData() &&
                            this?.app?.isPatient" class=" nav-item m-2">
                            <a data-aos="fade-down" data-aos-duration="800" class="text-lblue nav-link"
                                [routerLink]="'/' + app?.languageCode +'/become-doctor'">
                                {{ "NavBar.becomeDoctor" | translate }}<i></i></a>
                        </li>

                        <li class="nav-item m-2">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link"
                                [routerLink]=" '/' + app?.languageCode +'/Tebgram/activity'"
                                routerLinkActive="active">{{
                                "social.myCommAct" | translate }}</a>
                        </li>

                    </ul>

                    <ul class="navbar-nav">
                        <li class="nav-item f-19 my-2 p-cut mxx1 d-flex">
                            <img loading="lazy" data-aos="fade-down" data-aos-duration="800"
                                src="assets/img/navbar/arabic.svg" class="w-h-24 mx-1" alt="glob" />
                            <!-- <i class="fa fa-language"></i> -->
                            <!-- <mat-icon class="light-blueC" aria-hidden="false" aria-label="Example home icon">translate</mat-icon> -->

                            <mat-select data-aos="fade-down" data-aos-duration="800" class="fa select-non"
                                [value]="selectedLang" (selectionChange)="setLanguage($event)">
                                <mat-option class="fa" value="en">English</mat-option>
                                <mat-option class="fa" value="ar">العربية</mat-option>
                            </mat-select>
                        </li>

                        <!-- [routerLink]="'/login-page' -->
                        <li *ngIf="!this.app.getUserData()" class="nav-item align-items-center d-flex mx-2 res-btns ">
                            <a data-aos="fade-down" data-aos-duration="800"
                                class="nav-link btn-fill btn-w-h100 cursor-pointer" (click)="routeLogin()">
                                {{ "NavBar.LogIn" | translate }}
                            </a>
                        </li>

                        <li *ngIf="!this.app.getUserData()" class="nav-item align-items-center d-flex mx-2 res-btns ">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link btn-fill-light btn-w-h100"
                                [routerLink]="'/' + app?.languageCode +'/Register'">{{ "NavBar.SignUp"
                                | translate
                                }}</a>
                        </li>

                        <!-- <SSR> -->
                        <div *ngIf="app.isPlatformServerVar" style="display: none;visibility:hidden;opacity: 0;">
                            <p *ngIf="router?.url?.includes('/en/')">Login</p>
                            <p *ngIf="router?.url?.includes('/en/')">Sign Up</p>
                            <p *ngIf="router?.url?.includes('/ar/')">تسجيل الدخول</p>
                            <p *ngIf="router?.url?.includes('/ar/')">نشاء حساب</p>
                        </div>
                        <!-- </SSR> -->


                        <li class="nav-item dropdown" *ngIf="this.app.getUserData() && this.app.isPatient">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link dropdown-toggle a-cut"
                                href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <img loading="lazy" class="avatar-img rounded-circle img-profile"
                                    [src]="app.getUserImage(this?.app?.getUserData()?.picture)" alt="User Image" />
                            </a>
                            <ul [ngClass]="{'dropdown-menu-en': app?.languageCode === 'en'}" class="dropdown-menu"
                                aria-labelledby="navbarDropdown">

                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/patients/visit'">{{
                                        "NavBar.Visit" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/patients/relative'">{{
                                        "NavBar.Relatives" | translate
                                        }}</a></li>
                                <li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/patients/medical-history'">{{
                                        "NavBar.medicalhistory" | translate
                                        }}</a></li>
                                <li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/Tebgram/activity'">{{
                                        "social.myCommAct" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/Tebgram/profile'">{{
                                        "social.myCommProfile" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/patients/settings'">{{
                                        "NavBar.Settings" | translate
                                        }}</a></li>
                                <li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li><a class="dropdown-item" (click)="app?.mainLogOut()" href="javascript:void(0)">{{
                                        "NavBar.LogOut" | translate
                                        }}</a></li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown" *ngIf="this.app.getUserData() && this.app.isDoctor">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link dropdown-toggle a-cut"
                                href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <img loading="lazy" class="avatar-img rounded-circle img-profile"
                                    [src]="app.getUserImage(this?.app?.getUserData()?.picture)" alt="User Image" />
                            </a>
                            <ul [ngClass]="{'dropdown-menu-en': app?.languageCode === 'en'}" class="dropdown-menu"
                                aria-labelledby="navbarDropdown">

                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/doctor/appointment'">{{
                                        "NavBar.Appointments" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/doctor/available-timings'">{{
                                        "NavBar.availableTimings" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/doctor/schedule-session'">{{
                                        "medicalHis.ScheduleSession" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li *ngIf="this.app.isPMSubscribed"> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/doctor/clinics'">{{
                                        "medicalHis.ClinicManagement" | translate
                                        }}</a></li>
                                <li *ngIf="this.app.isPMSubscribed">
                                    <hr class="dropdown-divider">
                                </li>

                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/Tebgram/activity'">{{
                                        "social.myCommAct" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/Tebgram/profile'">{{
                                        "social.myCommProfile" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>


                                <li> <a class="dropdown-item" [routerLink]="'/' + app?.languageCode +'/inbox'">{{
                                        "message.inbox" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li> <a class="dropdown-item" [routerLink]="'/' + app?.languageCode +'/doctor/grant'">{{
                                        "social.grant" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/doctor/settings'">{{
                                        "NavBar.Settings" | translate
                                        }}</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>

                                <li><a class="dropdown-item" (click)="app?.mainLogOut()" href="javascript:void(0)">{{
                                        "NavBar.LogOut" | translate
                                        }}</a></li>

                            </ul>
                        </li>

                        <li class="nav-item dropdown" *ngIf="this.app.getUserData() && this.app.isContributor">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link dropdown-toggle a-cut"
                                href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <img loading="lazy" class="avatar-img rounded-circle img-profile"
                                    [src]="app.getUserImage(this?.app?.getUserData()?.picture)" alt="User Image" />
                            </a>
                            <ul [ngClass]="{'dropdown-menu-en': app?.languageCode === 'en'}" class="dropdown-menu"
                                aria-labelledby="navbarDropdown">

                                <li>
                                    <div class="classic-NoHover">
                                        <img loading="lazy" class="avatar-img rounded-circle img-profile-user"
                                            [src]="app.getUserImage(this?.app?.getUserData()?.picture)"
                                            alt="User Image" />

                                        <span class="userName mx-1">{{this?.app?.getUserData()?.englishName}}</span>
                                    </div>
                                </li>



                                <li class="my-2">
                                    <span class="textDivider">
                                        {{ 'social.users' | translate }}
                                    </span>
                                </li>

                                <li *ngFor="let hcp of app?.HcpsAuth">
                                    <div class="classic-p"
                                        [ngClass]="{'classic-pSelected': hcp?.id == app?.getSelectedHcpForCont()}"
                                        (click)="app?.setCont(hcp)">
                                        <img loading="lazy" class="avatar-img rounded-circle img-profile-user"
                                        [src]="app.getUserImage(hcp?.picture)" alt="User Image" />

                                        <span class="userName mx-1">{{hcp?.fullName}}</span>
                                    </div>
                                </li>



                                <!-- <li class="my-2"><a class="dropdown-item textDivider"
                                        [routerLink]="'/' + app?.languageCode +'/patients/settings'">{{
                                        "NavBar.Settings" | translate
                                        }}</a>
                                </li> -->



                                <li><a class="dropdown-item textDivider" (click)="app?.mainLogOut()"
                                        href="javascript:void(0)">{{
                                        "NavBar.LogOut" | translate
                                        }}</a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown" *ngIf="this.app.getUserData() && this.app.IsSocialMediaManager">
                            <a data-aos="fade-down" data-aos-duration="800" class="nav-link dropdown-toggle a-cut"
                                href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <img loading="lazy" class="avatar-img rounded-circle img-profile"
                                    [src]="app.getUserImage(this?.app?.getUserData()?.picture)" alt="User Image" />
                            </a>
                            <ul [ngClass]="{'dropdown-menu-en': app?.languageCode === 'en'}" class="dropdown-menu"
                                aria-labelledby="navbarDropdown">

                                <li>
                                    <div class="classic-NoHover">
                                        <img loading="lazy" class="avatar-img rounded-circle img-profile-user"
                                            [src]="app.getUserImage(this?.app?.getUserData()?.picture)"
                                            alt="User Image" />

                                        <span class="userName mx-1">{{this?.app?.getUserData()?.englishName}}</span>
                                    </div>
                                </li>

                                <li>
                                    <hr class="dropdown-divider">
                                </li>



                                <li> <a class="dropdown-item"
                                        [routerLink]="'/' + app?.languageCode +'/Tebgram/activity'">{{
                                        "social.myCommAct" | translate
                                        }}</a></li>

                                <li>
                                    <hr class="dropdown-divider">
                                </li>


                                <li><a class="dropdown-item textDivider" (click)="app?.mainLogOut()"
                                        href="javascript:void(0)">{{
                                        "NavBar.LogOut" | translate
                                        }}</a>
                                </li>
                            </ul>
                        </li>


                    </ul>


                </div>
            </div>
        </nav>
    </div>
</div>